// Local Dev
// export const BASE_URL = `http://${window.location.hostname}:8000`;
// export const FILE_SERVER_URL = `http://${window.location.hostname}:8000/files`;

// SEI PMO
export const BASE_URL = `https://enovatte-pm-go-ab7otfaira-et.a.run.app`;
export const FILE_SERVER_URL = `https://enovatte-pm-go-ab7otfaira-et.a.run.app/files`;
